import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

export const claimsSeoMetaData: SeoMetaData[] = [
  {
    path: '/claims',
    seo: {
      en: {
        title: 'My claims | Medicare',
        description: ''
      },
      es: {
        title: 'Mis reclamaciones | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/claims/claim-details',
    seo: {
      en: {
        title: 'Claim details | Medicare',
        description: ''
      },
      es: {
        title: 'Detalles sobre las reclamaciones | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/claims/claim-deductibles',
    seo: {
      en: {
        title: 'My deductible status | Medicare',
        description: ''
      },
      es: {
        title: 'El estatus de mi deducible | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  component: Component.Claims,
  ...seoMetaData
}))
